( function ( _s ) {
	/**
	 * Using the library serbanghita/form-to-object we create an object off the inputs of the form
	 * We also make it so that if any value on the object is an array we convert the values to comma
	 * separated values so that the URLs look shorter and the parameters on the AJAX calls are shorter
	 * to read too.
	 * @param _form
	 */
	const serializeFormData = _form => {
		const form = _form instanceof Element ? _form : _form.el[ 0 ];
		const data = window.formToObject( form, { includeEmptyValuedElements: true } );

		for ( const [ key, value ] of Object.entries( data ) ) {
			if ( Array.isArray( data[ key ] ) ) {
				data[ key ] = value.filter( n => n ).join( ',' ); //filter empty options just in case and comma separate
			}
		}
		return data;
	};

	const onFiltersChanged = ( _self, filterTarget = false ) => {
		_self.trigger( 'fr:filters-changed', {
			params: { ...serializeFormData( _self ), ...{ page: 1 } }, //change page number when filter changed,
			target: filterTarget,
		} );

		checkOrderByDropdown( _self, filterTarget );
	};

	/**
	 * When text search is made, disable the "order by" dropdown or enable it again if the search text is removed
	 * @param _self
	 * @param filterTarget
	 */
	const checkOrderByDropdown = ( _self, filterTarget ) => {
		if ( filterTarget && _s( filterTarget ).filter( '[name="search"], [name="s"]' ).length ) {
			const _orderBy = _self.find( '[name="order_by"]' );

			if ( _orderBy.length && filterTarget.value.length ) {
				const _default = _orderBy.find( '[data-default]' );

				if ( _default.length ) {
					_orderBy.firstElement().value = _default.attr( 'value' );
					if ( _orderBy.firstElement().slim )
						_orderBy.firstElement().slim.setSelected( _default.attr( 'value' ), false );
				}

				_orderBy.attr( 'disabled', true ).closest( 'label' ).addClass( 'disabled' );
			} else {
				_orderBy.removeAttr( 'disabled' ).closest( 'label' ).removeClass( 'disabled' );
			}
		}
	};

	const removeDropdownFilter = ( filter, filterData ) => {
		if ( filter.hasAttribute( 'multiple' ) ) {
			const currentlySelected = filter.slim.getSelected();
			filter.slim.setSelected(
				currentlySelected.filter( selected => selected !== filterData.filterOptionValue ),
				false
			);
		} else {
			/** First option is selected */
			filter.slim.setSelected( [] );
		}

		const selectedOptions = filter.slim.getSelected();

		if (
			! selectedOptions ||
			( Array.isArray( selectedOptions ) && ! selectedOptions.length )
		) {
			_s( filter ).trigger( 'fr:dropdown-selection-cleared' );
		}
	};

	const removeInputFilter = filter => {
		switch ( filter.type ) {
			case 'checkbox':
				filter.checked = false;
				break;
			case 'text':
				filter.value = '';
				break;
		}
	};

	const removeFilter = ( _filters, filterData ) => {
		const _filter = _filters.find( `[name="${ filterData.filter }"]` );

		if ( _filter.length ) {
			/**
			 * If more than one element, then pick the one with the provided value
			 * Example: Multiple checkboxes can have the same name, in that case select the one whose value attribute matches filterData.filterOptionValue
			 */
			const filter =
				_filter.length > 1
					? _filter.filter( `[value="${ filterData.filterOptionValue }"]` ).firstElement()
					: _filter.firstElement();

			if ( ! filter ) return;

			switch ( filter.tagName.toLowerCase() ) {
				case 'select':
					removeDropdownFilter( filter, filterData );
					break;
				case 'input':
					removeInputFilter( filter );
					/** For input tags, trigger change event */
					_s( filter ).trigger( 'change' );
					break;
			}
		}
	};

	_s.fn.cardGridFilters = function () {
		return this.each( function ( el ) {
			const _self = _s( el );

			_self.find( 'input, select' ).on( 'change', e => {
				onFiltersChanged( _self, e.target );
			} );

			_self.on( 'submit', e => {
				if ( _self.closest( '.card-grid-with-filters-module' ).length ) {
					e.preventDefault();
					onFiltersChanged( _self );
				}
			} );

			_self.on( 'fr:remove-filter', e => {
				removeFilter( _self, e.detail );
			} );

			_self.find( '[name="search"], [name="s"]' ).each( field => {
				checkOrderByDropdown( _self, field );
			} );
		} );
	};

	_s( document ).ready( function () {
		_s( '.card-grid-filters' ).cardGridFilters();
	} );
} )( window._s );
